<mat-form-field subscriptSizing="dynamic">
    @if (ngControl?.control) {
        <input
            matInput
            [matDatepicker]="picker"
            [placeholder]="placeholder"
            [formControl]="$any(ngControl!.control)"
            [min]="minDate"
            [max]="maxDate"
            [attr.data-uiid]="dataUiid"
            (dateChange)="onDateChange($event)"
        />
    } @else {
        <input
            matInput
            [matDatepicker]="picker"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [value]="value"
            [min]="minDate"
            [max]="maxDate"
            [attr.data-uiid]="dataUiid"
            (dateChange)="onDateChange($event)"
        />
    }

    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker
        #picker
        panelClass="cerrix-datepicker-panel"
        [calendarHeaderComponent]="calendarHeader"
    ></mat-datepicker>

    @if (ngControl?.control?.hasError("matDatepickerParse")) {
        <mat-error>Invalid date</mat-error>
    }

    @for (error of ngControl?.control?.errors | errorMessages; track error) {
        <mat-error>{{ error }}</mat-error>
    }
</mat-form-field>
